import { useState } from 'react';
import IconClassPicker from './editors/IconClassPicker';

export default function PageList({ pages, activePageId, onSelect, onAdd, onRename, onRemove }) {
  const [showAdd, setShowAdd] = useState(false);
  const [addingTitle, setAddingTitle] = useState('');
  const [addingIcon, setAddingIcon] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editingTitle, setEditingTitle] = useState('');
  const [editingIcon, setEditingIcon] = useState('');

  const handleAdd = () => {
    const title = addingTitle.trim();
    if (!title) return;
    onAdd({ title, icon: addingIcon || '' });
    setAddingTitle('');
    setAddingIcon('');
    setShowAdd(false);
  };

  const startEdit = (page) => {
    setEditingId(page.id);
    setEditingTitle(page.title);
    setEditingIcon(page.icon || '');
  };

  const saveEdit = () => {
    if (editingTitle.trim()) onRename(editingId, { title: editingTitle.trim(), icon: editingIcon || '' });
    setEditingId(null);
    setEditingTitle('');
    setEditingIcon('');
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditingTitle('');
    setEditingIcon('');
  };

  return (
    <div className="pagebuilder-page-list">
      <div className="pagebuilder-page-list-header">
        <span className="pagebuilder-page-list-title">
          <i className="bi bi-files me-1" aria-hidden="true" />Pages
        </span>
        <button
          type="button"
          className="pagebuilder-add-btn pagebuilder-add-btn--sm"
          onClick={() => setShowAdd((v) => !v)}
        >
          <i className={`bi ${showAdd ? 'bi-x-lg' : 'bi-plus-lg'}`} aria-hidden="true" />
          {showAdd ? 'Cancel' : 'New Page'}
        </button>
      </div>

      {showAdd && (
        <div className="pagebuilder-page-add-row">
          <div className="pagebuilder-page-edit-stack">
            <div className="pagebuilder-field-row">
              <input
                className="pagebuilder-page-input"
                value={addingTitle}
                onChange={(e) => setAddingTitle(e.target.value)}
                placeholder="Page title…"
                onKeyDown={(e) => { if (e.key === 'Enter') handleAdd(); if (e.key === 'Escape') setShowAdd(false); }}
                autoFocus
              />
              <button type="button" className="pagebuilder-add-btn pagebuilder-add-btn--sm" onClick={handleAdd}>
                Add
              </button>
            </div>
            <IconClassPicker
              value={addingIcon}
              label="Page Icon (optional)"
              placeholder="Search page icon..."
              maxRows={2}
              onChange={setAddingIcon}
            />
          </div>
        </div>
      )}

      <div className="pagebuilder-pages">
        {pages.map((page) => (
          <div
            key={page.id}
            className={`pagebuilder-page-item${page.id === activePageId ? ' pagebuilder-page-item--active' : ''}`}
          >
            {editingId === page.id ? (
              <div className="pagebuilder-page-edit-stack w-100">
                <input
                  className="pagebuilder-page-input pagebuilder-page-input--inline"
                  value={editingTitle}
                  onChange={(e) => setEditingTitle(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') saveEdit(); if (e.key === 'Escape') cancelEdit(); }}
                  autoFocus
                />
                <IconClassPicker
                  value={editingIcon}
                  label="Page Icon (optional)"
                  placeholder="Search page icon..."
                  maxRows={2}
                  onChange={setEditingIcon}
                />
                <div className="pagebuilder-field-row">
                  <button type="button" className="pagebuilder-add-btn pagebuilder-add-btn--sm" onClick={saveEdit}>Save</button>
                  <button type="button" className="pagebuilder-block-action-btn" onClick={cancelEdit}>Cancel</button>
                </div>
              </div>
            ) : (
              <button
                type="button"
                className="pagebuilder-page-select-btn"
                onClick={() => onSelect(page.id)}
              >
                <i className={page.icon || 'bi bi-file-earmark-text'} aria-hidden="true" />
                <span>{page.title}</span>
                {page.id === activePageId && (
                  <span className="pagebuilder-page-active-dot" aria-label="active" />
                )}
              </button>
            )}

            <div className="pagebuilder-page-actions">
              <button
                type="button"
                className="pagebuilder-block-action-btn"
                onClick={() => startEdit(page)}
                title="Rename page"
                aria-label="Rename page"
              >
                <i className="bi bi-pencil" />
              </button>
              <button
                type="button"
                className="pagebuilder-block-action-btn pagebuilder-block-action-btn--danger"
                onClick={() => onRemove(page.id)}
                disabled={pages.length === 1}
                title="Delete page"
                aria-label="Delete page"
              >
                <i className="bi bi-trash" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
